export var ServerStatusResult;
(function (ServerStatusResult) {
    ServerStatusResult["SUCCESS"] = "success";
    ServerStatusResult["ERROR"] = "error";
})(ServerStatusResult || (ServerStatusResult = {}));
